import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from 'components/CustomButtons/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Autocomplete from '@material-ui/lab/Autocomplete';

import { WithApp } from 'contexts/appContext';
import { wsCreate } from 'services/WService';
import { wsGet } from 'services/WService';
import { wsFindBy } from 'services/WService';

const useStyles = makeStyles(() => ({
  closeButton: {
    float: 'right',
  },
}));

export default WithApp(function ExchangeSeller(props) {
  const classes = useStyles();

  const showNotify = props.showNotify;

  const { open, setOpen, sellerId, customerBureau } = props;

  const handleClose = () => {
    setOpen(false);
    setCustomerPOne({});
    setCustomerPTwo({});
  };

  //cartera (Customer Portfolio)
  const [customerPOne, setCustomerPOne] = useState({});
  const [customerPTwo, setCustomerPTwo] = useState({});

  const [customerPIdTwo, setCustomerPIdTwo] = useState(undefined);

  async function saveExchange(data) {
    let response = await wsCreate('base/customer-portfolio-bureau/exchange-seller', {
      ...data,
      base_customer_portfolio_id: customerBureau.base_customer_portfolio_id,
      base_bureau_id: customerBureau.base_bureau_id,
    });
    if (response.success) {
      showNotify(response.message);
      props.reload();
    } else {
      showNotify(response.message, 'error');
    }
  }

  const [sellers, setSellers] = useState([]);

  async function listSellers() {
    let response = await wsFindBy('base/seller', 'not_assigned', false);
    if (response.success) {
      let data = response.data
        .filter((item) => item.id != sellerId)
        .map((item) => {
          return item;
        });

      if (sellerId === null) {
        setSellers(data);
      } else {
        setSellers([{ id: null, SlpCode: '-', SlpName: 'Sin vendedor' }, ...data]);
      }
    }
  }

  async function getSeller1() {
    let response = await wsGet('base/seller', sellerId);
    if (response.success) {
      setCustomerPOne(response.data);
    }
  }

  async function getSeller2(idSeller) {
    let response = await wsGet('base/seller', idSeller);
    if (response.success) {
      setCustomerPTwo(response.data);
    }
  }

  useEffect(() => {
    if (open) {
      listSellers();
      getSeller1();
    }
  }, [open]);

  return (
    <div>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>
          Intercambiar Carteras
          <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <h5>{customerPOne.SlpName}</h5>
          <p>
            Cartera:{' '}
            {Object.keys(customerPOne).length > 0 && customerPOne.customerPortfolio != null
              ? customerPOne.customerPortfolio.description
              : 'No tiene cartera'}
          </p>

          <div style={{ fontWeight: 'bold', marginTop: '40px' }}>
            {' '}
            Elija vendedor y cartera al que desea asignar:
          </div>
          <Autocomplete
            options={sellers}
            getOptionLabel={(option) => option.SlpName}
            defaultValue={null}
            renderInput={(params) => (
              <TextField {...params} label="Vendedor cambiante" margin="normal" />
            )}
            onChange={(e, item) => {
              if (!!item) {
                if (item.id !== null) {
                  getSeller2(item.id);
                }
                setCustomerPIdTwo(item.id);
              } else {
                setCustomerPIdTwo(undefined);
              }
            }}
          />
          <p>
            Cartera:{' '}
            {Object.keys(customerPTwo).length > 0 && customerPTwo.customerPortfolio != null
              ? customerPTwo.customerPortfolio.description
              : 'No tiene cartera'}
          </p>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              saveExchange({
                original_seller_id: sellerId,
                seller_id: customerPIdTwo,
              });
              handleClose();
            }}
            color={props.themeContext.buttonColorSuccess}
            size="sm"
            disabled={customerPIdTwo === undefined}
          >
            Aceptar
          </Button>
          <Button onClick={handleClose} color={props.themeContext.buttonColorDanger} size="sm">
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
});
